import React, { Component } from 'react';
import { Button, Modal, Spin } from 'antd';
import { TestWrapper } from './style';
import { shuffleArray, setAnswerList } from '../../common/utils';

class TestWallet extends Component {
	state = {
		count: 1,
		answer: setAnswerList(),
		seeds: [],
		isLoading: false
	};

	componentDidMount() {
		this.initialSeeds();
		this.setRandomNumber();
	}

	initialSeeds = () => {
		const { data } = this.props;
		this.setState({ seeds: data });
	};

	setRandomNumber = (count = 1) => {
		this.setState({ count });
	};

	setAnswer = (num) => {
		const { onSubmit } = this.props;
		const { answer, count } = this.state;
		if (num === answer[count - 1]) {
			if (count === 4) {
				this.setState({ isLoading: true });
				onSubmit();
			} else {
				this.setRandomNumber(count + 1);
			}
		} else {
			Modal.error({
				title: 'Error',
				content: 'Selected wrong word. Please try again.',
				onOk: () => {
					this.setState({ count: 1 });
				}
			});
		}
	};

	renderOption = () => {
		const { answer, seeds, count } = this.state;
		const ans = answer[count - 1];
		const array = [
			ans,
			Math.abs(12 - (ans + 1)),
			Math.abs(12 - (ans + 2)),
			Math.abs(12 - (ans + 3))
		];
		const shuffle = shuffleArray(array);
		const Options = shuffle.map((num) => {
			return (
				<Button
					type="primary"
					onClick={() => {
						this.setAnswer(num);
					}}
				>
					{seeds[num]}
				</Button>
			);
		});
		return Options;
	};

	render() {
		const { onCancel } = this.props;
		const { answer, count, isLoading } = this.state;
		return (
			<TestWrapper>
				<p>Pick the correct word({count}/4)</p>
				<h3>What is the word in position {answer[count - 1] + 1} out of 12 words?</h3>
				<div className="option-area">{this.renderOption()}</div>
				<div className="btn-area">
					<Button onClick={onCancel}>Back</Button>
				</div>
				{isLoading && (
					<div className="spin-wrapper">
						<Spin size="large" />
					</div>
				)}
			</TestWrapper>
		);
	}
}

export default TestWallet;
